import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { openArchiveModal } from 'web-interactives-dashboard-ui/actions/ModalActions';
import { getIsReadOnly } from 'web-interactives-dashboard-ui/selectors/appStateSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ArchiveMenuAction = ({
  name,
  interactiveId,
  isArchived,
  objectId
}) => {
  const dispatch = useDispatch();
  const isReadOnly = useSelector(getIsReadOnly);
  const handleArchive = () => {
    dispatch(openArchiveModal({
      interactiveIds: [interactiveId],
      name,
      objectIds: [objectId],
      shouldArchive: !isArchived
    }));
  };
  return /*#__PURE__*/_jsx(Button, {
    disabled: isReadOnly,
    onClick: handleArchive,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `actionMenu.${isArchived ? 'unarchive' : 'archive'}`
    })
  });
};
export default ArchiveMenuAction;